exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Separator__horizontal{height:1px}.Separator__vertical{width:1px}.Separator__error{background-color:#c02}.Separator__light{background-color:#cfd8dc}", ""]);
